import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import HomeCarousel from "../../components/Home/HomeCarousel/HomeCarousel";
import SearchNav from "../../components/Home/SearchNav/SearchNav";
import CircleCard from "../../components/Home/CircleCard/CircleCard";
import SquareImageCard from "../../components/Home/SquareImageCard/SquareImageCard";
import ProductCard from "../../components/Home/ProductCard/ProductCard";
import ProductCardLarge from "../../components/Home/ProductCardLarge/ProductCardLarge";
import BannerHire from "../../components/Home/BannerHire/BannerHire";
import ImageBanner from "../../components/Home/ImageBanner/ImageBanner";
import Footer from "../../components/Footer/Footer";
import axios from "axios";
import { BASE_URL } from "../../constant/api";
import { useSession } from "../../ApiCalls/useSession";
import CircularImageList from "../../components/Home/CircularImageList/CircularImageList";
import LearnMoreCard from "../../components/Home/LearnMoreCard/LearnMoreCard";
import DoubleRowProductCard from "../../components/DoubleRowProductCard/DoubleRowProductCard";
import AppBanner from "../../components/AppBanner/AppBanner";
import RewardBanner from "../../components/Home/RewardBanner/RewardBanner";
import Brand from "../../components/Brands/Brand";
import ImageCarousel from "../../components/Home/ImageCarousel/ImageCarousel";
import SearchNavsmall from "../../components/Home/SearchNav/SearchNavsmall";

function Home() {
  useSession();

  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [trendingBrands, setTrendingBrands] = useState([]);
  const [Sponsored, setSponsored] = useState([
    // {
    //   id: 1,
    //   banner: "images/Promotion/Banner/Banner_web1.jpg",
    //   title: "Republic Day",
    //   start_date: "2025-01-28",
    //   end_date: "2025-05-28",
    //   path: "/registration",
    // },
    {
      id: 1,
      banner: "/images/Promotion/Sponser/s1.jpg",
      title: "Summer Sale",
      start_date: "2025-06-01",
      end_date: "2025-06-30",
      path: "/"
    },
    // {
    //   id: 3,
    //   banner: "/media/sponsored_banners/sponserbanner_XYZ456.jpg",
    //   title: "Diwali Festival Offer",
    //   start_date: "2025-10-15",
    //   end_date: "2025-11-05",
    // }
  ]);

  const [nearestBrand, setNearestBrand] = useState([]);
  const [products, setProducts] = useState([]);
  const [banners, setBanners] = useState([
    {
      id: 1,
      banner: "/images/Promotion/Banner/1.jpg",
      title: "No one concrete product online store",
      start_date: "2025-01-24",
      end_date: "2025-01-25",
      path:"/registration"
    },
    {
      id: 2,
      banner: "images/Promotion/Banner/2.jpg",
      title: "Best Deals on Electronics",
      start_date: "2025-01-26",
      end_date: "2025-01-30",
      path: "/"
    },
    {
      id: 3,
      banner: "/images/Promotion/Banner/3.jpg",
      title: "Fashion Trends 2025",
      start_date: "2025-02-01",
      end_date: "2025-02-05",
      path: "/registration"
    },
        {
      id: 3,
      banner: "/images/Promotion/Banner/4.jpg",
      title: "Fashion Trends 2025",
      start_date: "2025-02-01",
      end_date: "2025-02-05",
          path: "/"
    },
        {
      id: 3,
          banner: "/images/Promotion/Banner/5.jpg",
      title: "Fashion Trends 2025",
      start_date: "2025-02-01",
      end_date: "2025-02-05",
      path: "/search"
    },
  ]);

  const [trendingProducts, setTrendingProducts] = useState([]);
  const [offerProducts, setOfferProducts] = useState([]);
  const [fastMovingProducts, setFastMovingProducts] = useState([]);
  const [TopRated, setTopRated] = useState([]);
  const [userAddress, setUserAddress] = useState(null);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  const bulldeals = [
    {
      id: 9,
      name: "TMT Steel Bars",
      image: "/images/products/steel.png",
      description: "Fe 550 Grade",
      discount: 0,
      price: 6.70,
    },
  ];

  useEffect(() => {
    console.log("Component mounted");

    // Check if geolocation is supported
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        position => {
          const { latitude, longitude } = position.coords;
          setLatitude(latitude);  // Set latitude in state
          setLongitude(longitude);  // Set longitude in state
        },
        error => {
          console.error("Error obtaining location:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  }, []);

  const fetchData = async (url, setter) => {
    try {
      const response = await axios.get(url);
      const data = response.data.Data || response.data.data;
      console.log(url, data);
      if (data) {
        setter(data);
      }

    } catch (error) {
      console.error(`Error fetching data from ${url}:`, error);
      const errorMessage = error.response?.data?.message || "Failed to fetch data";
    }
  };

  useEffect(() => {
    // fetchData(`${BASE_URL}/products/banners/`, setBanners);
    fetchData(`${BASE_URL}/products/trending/`, setTrendingProducts);
    fetchData(`${BASE_URL}/products/special-offers/`, setOfferProducts);
    fetchData(`${BASE_URL}/products/fast-moving/`, setFastMovingProducts);
    fetchData(`${BASE_URL}/products/top-rated/`, setTopRated);
    fetchData(`${BASE_URL}/categories/`, setCategories);
    fetchData(`${BASE_URL}/products/trending-brands/`, setTrendingBrands);
    fetchData(`${BASE_URL}/categories/subcategories/`, setSubCategories);
    // fetchData(`${BASE_URL}/products/sponsored/`, setSponsored);

    // Fetch nearest supplier data if latitude and longitude are available
    if (latitude && longitude) {
      fetchData(
        `${BASE_URL}/products/nearest-supplier/?latitude=${latitude}&longitude=${longitude}&radius=20`,
        setNearestBrand
      );
    }
  }, [latitude, longitude]);

  return (
    <div className="container mx-auto">
      {/* <SearchNav /> */}
      <div className="block md:hidden">
      <SearchNavsmall />
      </div>
  
      {banners.length > 0 && <HomeCarousel items={banners} />}
      {categories.length > 0 && (
        <div className="bg-white py-3 my-5">
          <CircleCard data={categories} bg="bg-white" title="Categories" />
        </div>
      )}
      {subCategories.length > 0 && (
        <div className="bg-[#E8FDE7] my-2  pt-5">
          <CircularImageList data={subCategories} bg="bg-white" title="Sub Categories" />
        </div>
      )}
      <Brand />
      {nearestBrand.length > 0 && (
        <SquareImageCard
          data={nearestBrand}
          title="Nearest Suppliers"
          bg="bg-white"
        />
      )}
      {trendingProducts.length > 0 && (
        <ProductCard products={trendingProducts} title="Trending Products" bg="#E8FDE7" view_all_url="" />
      )}
      {Sponsored.length > 0 && (
        <ImageCarousel products={Sponsored} title="Sponsored" view_all_url="/sponsored/all" />
      )}
      {offerProducts.length > 0 && (
        <ProductCard
          products={offerProducts}
          title="Offer Products"
          bg="#E8FDE7"
          view_all_url="/offers"
        />
      )}
      {/* <BannerHire /> */}
      {TopRated.length > 0 && (
        <DoubleRowProductCard products={TopRated} title="Top Rated Products" bg="#cfdefa" />
      )}
      {fastMovingProducts.length > 0 && (
        <ProductCard products={fastMovingProducts} title="Fast Moving Items" bg="#E8FDE7" />
      )}
      {/* <RewardBanner />
      <AppBanner /> */}

      {/* <LearnMoreCard bg="bg-[#05BF0280]" title="EMI Option is" title2="Available" img='/images/LearnMoreCardImg/Two.png' url='www.demo.com' /> */}

      {/* <div className="flex flex-col md:flex-row items-center justify-between bg-white p-4 md:p-6">
        <p className="text-black uppercase font-semibold text-center md:text-left mb-2 md:mb-0">
          Available Payment Options
        </p>
        <div className="flex flex-row space-x-4">
          <img src="/images/payment_options/visa.png" alt="Visa" className="h-5" />
          <img src="/images/payment_options/mc.png" alt="MasterCard" className="h-5" />
          <img src="/images/payment_options/cod.png" alt="Cash on Delivery" className="h-5" />
        </div>
      </div> */}
    </div>
  );
}

export default Home;
